import React, { useEffect }from "react";
import  debounce  from "debounce";

const SingleAlbumGrid = ({childElements})=>{
   
    useEffect(() => {
        $('#single_album_grid').collagePlus();
        window.addEventListener('resize', debounce( (event) => {
            $('#single_album_grid').collagePlus();
            console.log("resize triggered")
            $('#single_album_grid').collagePlus();
        },200));  
        setTimeout(function(){
            $('#single_album_grid').collagePlus();
        },0) 
        setTimeout(function () {
            try {
                //added lazy loading call
                photoOrg.Util.lazyLoading($("img.lazy"), $("#album_assets").find('.scroll_sav_grid'));
            } catch (e) {
                photoOrg.cLog("error using lazyloading method", 'warn');
            }
        }, 100)     
    },[])
    
    return(
        <div  id="single_album_grid" className="collage sortable">{childElements}</div>
    )

}
export default SingleAlbumGrid;